import one360 from './one360';

export const getDocumentTypes = async (phaseId?: string) => {
  const params = phaseId ? { phaseId } : undefined;
  return one360.get('/api/v1/document-types', { params });
};
